// extracted by mini-css-extract-plugin
export var aliyunCaptcha = "businessEnquiry-module--aliyunCaptcha--928d5";
export var boxOption = "businessEnquiry-module--boxOption--a97cd";
export var boxYellow = "businessEnquiry-module--boxYellow--51990";
export var buttonCta = "businessEnquiry-module--buttonCta--1a083";
export var cbox = "businessEnquiry-module--cbox--48277";
export var checkBoxSecondary = "businessEnquiry-module--checkBoxSecondary--66206";
export var checkbox = "businessEnquiry-module--checkbox--c306d";
export var checkboxAlign = "businessEnquiry-module--checkboxAlign--552c1";
export var checkboxCont = "businessEnquiry-module--checkboxCont--3fe77";
export var checkboxWidthTerm = "businessEnquiry-module--checkboxWidthTerm--c96cf";
export var cta = "businessEnquiry-module--cta--4bfd9";
export var errorMessage = "businessEnquiry-module--errorMessage--215dc";
export var formBusinessEnquiry = "businessEnquiry-module--formBusinessEnquiry--116da";
export var formBusinessEnquiryContent = "businessEnquiry-module--formBusinessEnquiryContent--56590";
export var formBusinessEnquiryWrapper = "businessEnquiry-module--formBusinessEnquiryWrapper--13f38";
export var formContainer = "businessEnquiry-module--formContainer--2bb15";
export var formControl = "businessEnquiry-module--formControl--3af9d";
export var fullColumn = "businessEnquiry-module--fullColumn--2eef2";
export var halfColumn = "businessEnquiry-module--halfColumn--e9a3e";
export var header = "businessEnquiry-module--header--fe89b";
export var highlight = "businessEnquiry-module--highlight--6094a";
export var icon = "businessEnquiry-module--icon--bb6a8";
export var iptComp = "businessEnquiry-module--iptComp--03da4";
export var iptTel = "businessEnquiry-module--iptTel--4fc1a";
export var optionsWrapper = "businessEnquiry-module--optionsWrapper--18845";
export var recaptcha = "businessEnquiry-module--recaptcha--b6005";
export var row = "businessEnquiry-module--row--6fb9b";
export var submit = "businessEnquiry-module--submit--c2317";
export var termsPrivacy = "businessEnquiry-module--termsPrivacy--e68c0";
export var text = "businessEnquiry-module--text--f7b06";
export var timeSlot = "businessEnquiry-module--timeSlot--85865";
export var title = "businessEnquiry-module--title--6b4cf";
export var txtOption = "businessEnquiry-module--txtOption--68880";
export var txtTellUs = "businessEnquiry-module--txtTellUs--2675d";